"use client";
import React from "react";
import Image from "next/image";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Badge } from "@/components/hongkong-setup-v2/ui/badge";
import { Button } from "@/components/hongkong-setup-v2/ui/button";
import { Card, CardContent } from "@/components/hongkong-setup-v2/ui/card";
import { WA_NUMBERS } from "@/lib/consultation-links";
import { openWhatsAppWithUtm } from "@/lib/whatsapp";


const features = [
  {
    icon: "/hongkong-setup-v2/container-2.svg",
    title: "Hong Kong Company Formation",
    description:
      "Full Hong Kong Limited Company formation — registered address, company secretary, government registration, certificate of incorporation",
  },
  {
    icon: "/hongkong-setup-v2/container-5.svg",
    title: " Insider-Backed PSP Setup",
    description:
      "Insider-backed PSP account setup — connected to processors who specialize in high-volume eCommerce (no algorithmic ban risk)",
  },
  {
    icon: "/hongkong-setup-v2/Container-ls-3.svg",
    title: "Stable Hong Kong PayPal",
    description:
      "Verified Hong Kong Business PayPal — the most stable PayPal tier on the planet, period",
  },
  {
    icon: "/hongkong-setup-v2/container-4.svg",
    title: "HK Multi-Currency Banking",
    description:
      "Multi-currency HK business bank account — receive funds globally with institutional-grade banking",
  },
   {
    icon: "/hongkong-setup-v2/Container-ls-5.svg",
    title: "Hassle-Free Compliance",
    description:
      "Full compliance documentation and annual filing management — everything stays clean, always",
  },
   {
    icon: "/hongkong-setup-v2/Container-ls-6.svg",
    title: "Real Human Support",
    description:
      "Dedicated account manager — not a chatbot, not a ticket system, a real human who picks up the phone",
  },
   {
    icon: "/hongkong-setup-v2/container-7.svg",
    title: "Fully Operational in 7 Days",
    description:
      "7-day delivery — from zero to fully operational in one week flat",
  },
];

const stats = [
  {
    value: "5000+",
    label: "PSPs Approved",
  },
  {
    value: "2500+",
    label: "HK Companies created",
  },
];

const benefits = [
  "Full support until PSP is active",

  "HK Company + Bank formation",
  "Fully active payment processing ",
  "Personal guidance & insider strategies",
];

export const SpecialistServicesSection = () => {
  return (
    <section className="flex flex-col lg:flex-row w-full max-w-[1440px] sm:mx-6 md:mx-8 lg:mx-auto items-start justify-center gap-8 sm:gap-12 md:gap-16 lg:gap-[100px] px-4 sm:px-6 md:px-8 lg:px-12 xl:px-[101px] py-8 sm:py-12 lg:py-[70px] relative">
      <div className="inline-flex flex-col items-start gap-8 sm:gap-10 md:gap-12 lg:gap-[57px] relative flex-[0_0_auto] w-full lg:w-auto">
        <div className="inline-flex flex-col items-start gap-4 sm:gap-[18px] relative flex-[0_0_auto] w-full">
          <h2 className="font-normal leading-[120%] relative w-full text-[36px] md:text-[70px]">
            <span className=" bg-[radial-gradient(38.63%_62.02%_at_43.72%_20.95%,#155dfc_0%,#FFF_100%)] bg-clip-text text-transparent">
              Hong Kong {" "}
            </span>
            <br/>
              <span className=" font-normal text-white tracking-[0.31px]">
                PSP Specialist
              </span>
            
          </h2>

          <p className="relative w-full lg:w-[622px] font-inter font-[300] text-[#a0a4b3] text-base sm:text-[18px] md:text-xl tracking-[0] leading-[24px] sm:leading-[27px] md:leading-[29.2px]">
            MuteTaxes has assisted in forming more than 3000 Hong Kong companies and has extensive experience guiding clients through complex payment compliance requirements. 
          </p>
        </div>

        <div className="flex flex-col w-full lg:w-[664px] items-start gap-8 sm:gap-10 md:gap-12 lg:gap-[33px] relative">
          {features.map((feature, index) => (
            <div
              key={index}
              className="relative flex items-start w-full gap-3 sm:gap-4"
            >
              <Image
                className="relative flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12"
                alt={feature.title}
                src={feature.icon}
                width={800}
                height={600}
              />
              <div className="relative flex flex-col items-start flex-1 gap-1.5 sm:gap-2">
                <h3 className="relative w-full font-inter font-normal text-[#ffffff] text-base sm:text-lg tracking-[0] leading-5 sm:leading-6">
                  {feature.title}
                </h3>
                <p className="relative w-full font-inter font-normal text-[#a0a4b3] text-sm sm:text-base tracking-[0] leading-[20px] sm:leading-[22.8px]">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Card className="flex flex-col w-full lg:w-[448px] items-start gap-4 sm:gap-5 md:gap-6 py-6 sm:py-7 md:py-[33px] px-6 sm:px-7 md:px-[33px] relative bg-[#0a0f1e] rounded-2xl sm:rounded-3xl shadow-[0px_25px_50px_-12px_#00000040] border-0">
        <CardContent className="w-full p-0">
          <div className="relative w-full h-[120px] sm:h-[140px] md:h-[164px]">
            <div className="flex w-[120px] sm:w-[140px] md:w-[158px] h-6 sm:h-7 items-start absolute top-20 sm:top-24 md:top-28 left-1/2 transform -translate-x-1/2 md:left-28 md:transform-none">
              <div className="relative flex-1 mt-[-1.00px] font-inter font-normal text-[#ffffff] text-lg sm:text-xl text-center tracking-[0] leading-6 sm:leading-7">
                MuteTaxes
              </div>
            </div>
            <Image
              className="absolute top-px left-1/2 transform -translate-x-1/2 md:left-[145px] md:transform-none w-[80px] h-[80px] sm:w-[90px] sm:h-[90px] md:w-[98px] md:h-[98px]"
              alt="MuteTaxes"
              src="/logo.svg"
              width={800}
              height={600}
            />
          </div>

          <div className="grid grid-cols-2 gap-3 sm:gap-4 w-full mt-5 sm:mt-10 md:mt-[45px]">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="flex flex-col items-start gap-1 px-0 py-[3px] bg-[#161616] rounded-[10px]"
              >
                <div className="flex items-start w-full h-7 sm:h-8">
                  <div className="relative flex-1 mt-[-1.00px] font-inter font-normal text-[#ffffff] text-xl sm:text-2xl text-center tracking-[0] leading-7 sm:leading-8">
                    {stat.value}
                  </div>
                </div>
                <div className="flex items-start w-full h-4">
                  <div className="relative flex-1 mt-[-1.00px] font-inter font-normal text-[#585d70] text-xs text-center tracking-[0] leading-4">
                    {stat.label}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <Card className="relative w-full mt-4 sm:mt-5 md:mt-6 bg-[#161616] rounded-xl sm:rounded-2xl border border-solid border-[#31415780]">
            <CardContent className="p-0">
              <div className="flex justify-center pt-4 sm:pt-5 md:pt-[25px]">
                <Badge className="h-6 sm:h-7 px-3 sm:px-4 py-1 sm:py-1.5 bg-[#3a383e] rounded-[33554400px] border-0">
                  <span className="font-inter font-normal text-[#ffffff] text-[10px] sm:text-xs tracking-[0.30px] leading-3 sm:leading-4">
                    MONEY BACK GUARANTEE
                  </span>
                </Badge>
              </div>

              <div className="flex justify-center mt-3 sm:mt-4 md:mt-[19px]">
                <div className="w-full h-10 sm:h-12 bg-[linear-gradient(138deg,rgba(111,166,255,1)_0%,rgba(51,92,255,1)_100%)] [-webkit-background-clip:text] bg-clip-text [-webkit-text-fill-color:transparent] [text-fill-color:transparent] font-inter font-normal text-transparent text-3xl sm:text-4xl md:text-5xl text-center tracking-[0] leading-[40px] sm:leading-[48px]">
                  <span className="font-medium text-black">€</span>
                  <span className="font-inter text-black">
                    3000
                  </span>
                </div>
              </div>

              <div className="flex flex-col items-start gap-1.5 sm:gap-2 px-4 sm:px-5 md:px-[25px] mt-2 sm:mt-3 md:mt-[12px]">
                <h3 className="relative w-full font-inter font-normal text-[#ffffff] text-base sm:text-lg text-center tracking-[0] leading-6 sm:leading-7">
                  Complete Hong Kong PSP Setup
                </h3>
                <p className="relative w-full font-inter font-normal text-[#585d70] text-xs sm:text-sm text-center tracking-[0] leading-4 sm:leading-5">
                  We ensure your complete payment processor
                  <br />
                  setup is ready to go
                </p>
              </div>

              <div className="flex flex-col items-start gap-2 sm:gap-3 px-4 sm:px-5 md:px-[25px] mt-4 sm:mt-5 md:mt-6">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className="flex items-center w-full h-5 gap-2"
                  >
                    <Image
                      className="relative flex-shrink-0 w-3.5 h-3.5 sm:w-4 sm:h-4"
                      alt="Check"
                      src="/hongkong-setup-v2/icon.svg"
                      width={800}
                      height={600}
                    />
                    <div className="flex items-start">
                      <span className="font-inter font-normal text-[#a0a4b3] text-xs sm:text-sm tracking-[0] leading-4 sm:leading-5">
                        {benefit}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="flex flex-col items-start gap-2 sm:gap-3 px-4 sm:px-5 md:px-[25px] mt-4 sm:mt-5 md:mt-6">
                <Alert className="mt-4 sm:mt-5 md:mt-6 bg-[#82181a4c] rounded-[12px] sm:rounded-[14px] border border-solid border-[#9e071180] p-2 sm:p-[13px]">
                  <AlertDescription className="flex items-start gap-1.5 sm:gap-2">
                    <Image
                      className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex-shrink-0 mt-0.5"
                      alt="Warning"
                      src="/hongkong-setup-v2/icon-1.svg"
                      width={800}
                      height={600}
                    />
                    <span className="font-inter font-normal text-[#ffa1a2] text-[10px] sm:text-xs tracking-[0] leading-3 sm:leading-4">
                      Please ensure you have{" "}
                      <span className="font-inter font-bold">
                        €3
                      </span>
                      000 ready before reaching out
                    </span>
                  </AlertDescription>
                </Alert>
              </div>
              <div className="relative px-4 sm:px-5 md:px-[25px] mt-4 sm:mt-5 md:mt-[21px]">
                <button
                  type="button"
                  onClick={() => openWhatsAppWithUtm(WA_NUMBERS, "hk-setup")}
                  className="cursor-pointer h-9 px-4 py-2
    relative
    w-full sm:w-auto
    inline-flex items-center justify-center gap-2
    sm:px-7  sm:py-6
    rounded-[24px]
    bg-[#335cff]
    text-white
    font-bold
    overflow-hidden
    transition-all duration-300 ease-out
    hover:scale-[1.03]
    hover:-translate-y-1
    hover:shadow-[0_12px_30px_rgba(51,92,255,0.45)]
    hover:bg-gradient-to-r hover:from-[#476cff] hover:to-[#004eff]
    active:scale-[0.98]
    "
                >
                  <div className="hidden sm:block absolute top-[37px] left-1 w-[326px] h-20 bg-[#d9d9d9] rounded-[163px/40px] blur-[27px]" />
                  <span className="font-inter font-medium  text-[#ffffff] text-sm sm:text-base md:text-lg tracking-[-0.36px] leading-6 sm:leading-7 relative px-2">
                    Start Your Hong Kong PSP Setup
                  </span>
                </button>
              </div>

              <div className="flex justify-center px-4 sm:px-5 md:px-[25px] mt-3 sm:mt-4 pb-4 sm:pb-5 md:pb-[25px]">
                <span className="font-inter font-normal text-[#585d70] text-[10px] sm:text-xs text-center tracking-[0] leading-3 sm:leading-4">
                  For global entrepreneurs
                </span>
              </div>
            </CardContent>
          </Card>

          <div className="flex flex-col items-start w-full gap-3 sm:gap-4 mt-4 sm:mt-5 md:mt-6">
            <div className="flex items-start w-full">
              <span className="relative flex-1 mt-[-1.00px] font-inter font-normal text-[#ffffff] text-xs sm:text-sm text-center tracking-[0] leading-4 sm:leading-5">
                Discover our mutual connections:
              </span>
            </div>

            <Button
              asChild
              variant="outline"
              className="
    w-full h-10 sm:h-11 md:h-[46px]
    bg-[#161616]
    rounded-[12px] sm:rounded-[14px]
    border border-[#31415780]
    transition-all duration-300

    hover:bg-[#161616]
   
  
  "
            >
              <a
                href="/contact"
                className="flex items-center justify-center gap-1.5 sm:gap-2"
              >
                <Image
                  className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                  alt=""
                  src="/hongkong-setup-v2/icon-3.svg"
                  width={800}
                  height={600}
                />
                <span className="font-normal text-[#155dfc] text-xs sm:text-sm leading-4 sm:leading-5">
                  Contact Us
                </span>
              </a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};
